import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { categoryApi } from 'container/categoryApi';

import { STORE_NAME } from './initialState';

export const fetchProjectCategories = createAsyncThunk(
  `${STORE_NAME}/fetchProjectCategories`,
  ({ projectId }: { projectId: number }) => {
    return categoryApi.list(projectId);
  },
  { serializeError },
);
